import UltaAsset from '@ulta/core/components/UltaAsset/UltaAsset';

export default UltaAsset;